import AppliedFilters from '@bd/bdui-appliedfilters';
import styled from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

export default styled(AppliedFilters)`
  position: relative;
  .AppliedFilters_list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: inline-block;
    @media (min-width: 992px) {
      padding: 10px 0;
    }
    &:before {
      content: 'Applied Filters:';
      display: block;
      margin: 0 10px 0 0;
      font-size: 12px;
      font-weight: 700;
      @media (min-width: 992px) {
        font-size: 14px;
        display: inline-block;
      }
    }
    .AppliedFilters_listItem {
      display: inline-block;
      margin: 0 10px 5px 0;
    }
    .AppliedFilters_listItemButton {
      padding: 5px 7px 5px 19px;
      font-weight: 400;
      font-size: 12px;
      background-image: url('/images/icon-close.svg');
      background-position: 7px center;
      background-repeat: no-repeat;
      background-size: 7px 7px;
      cursor: pointer;
      background-color: ${colors.neutral};
      display: block;
      border-radius: 3px;
      @media (min-width: 992px) {
        font-size: 13px;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/AppliedFilters.js